import { useSpeakerIdentificationPrefetch } from '@src/hooks/useSpeakerIdentificationPrefetch';

/**
 * Starts speaker identification in the background as this session's uploads
 * progress (see useSpeakerIdentificationPrefetch). Renders nothing.
 */
const SpeakerIdentificationPrefetcher = () => {
  useSpeakerIdentificationPrefetch();
  return null;
};

export default SpeakerIdentificationPrefetcher;
